import { getExerciseTypeVersionAdapter, LATEST_SCHEMA_VERSION } from '@datacamp/exercise-types';
const exerciseTypeVersionAdapter = getExerciseTypeVersionAdapter('DragAndDropExercise', LATEST_SCHEMA_VERSION.DragAndDropExercise);
export default exerciseTypeVersionAdapter;